import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SecurityService } from '../../security/security.service';
import { User } from '../../security/interfaces/user.interface';

@Injectable()
export class CookieInterceptor implements HttpInterceptor {

  constructor(private securityService: SecurityService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let currentUser: User;

    this.securityService.currentUser$.pipe(take(1)).subscribe(user => currentUser = user);
    if (currentUser) {
      request = request.clone({
        setHeaders: {
          Clientcookie: currentUser.clientCookie
        }
      })
    }

    return next.handle(request);
  }
}
